import React from 'react';
import { AuthProvider } from './src/context';
import { trackPageTime } from '../shared/utils/Analytics';
import { UserProgressContextProvider } from './src/context/UserProgressContext';
import './src/styles/global.css';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

const client = new ApolloClient({
  uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}/environments/master?access_token=${process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN || process.env.CONTENTFUL_ACCESS_TOKEN || ''}`,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN || process.env.CONTENTFUL_ACCESS_TOKEN || ''}`,
  },
});

if (process.env.NODE_ENV !== 'production') {
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

let previousSearch = '';

export const onRouteUpdate = (location, prevLocation) => {
  if (typeof window !== 'undefined') {
    // Fire PageViewPing for the previous page
    if (prevLocation || previousSearch !== window.location.search) {
      trackPageTime();
    }
    // Update the stored query string
    previousSearch = window.location.search;
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <UserProgressContextProvider>
        <ApolloProvider client={client}>{element}</ApolloProvider>
      </UserProgressContextProvider>
    </AuthProvider>
  );
};
